import { format, getDaysInMonth, subMonths } from "date-fns";

const uiFormat = "dd.MM.yyyy";
const uiDateTimeFormat = "dd.MM.yyyy HH:mm";
const apiFormat = "yyyy-MM-dd";

export const formatToUi = (dateTime: Date): string => {
	return format(dateTime, uiFormat);
};

export const formatDateTimeToUi = (dateTime: Date): string => {
	return format(dateTime, uiDateTimeFormat);
};

export const formatApiDate = (value?: string | null, withTime = false): string => {
	if (!value) {
		return "N/A";
	}

	const date = new Date(value);
	if (isNaN(date.getTime())) {
		return "N/A";
	}
	return withTime ? formatDateTimeToUi(date) : formatToUi(date);
};

export const formatToApi = (dateTime: Date): string => {
	return format(dateTime, apiFormat);
};

export const getStartDateFromPeriod = (month: number, year: number): Date => {
	const startDate = new Date(year, month - 1, 1);
	return startDate;
};
export const getEndDateFromPeriod = (month: number, year: number): Date => {
	const dateToDay = getDaysInMonth(new Date(year, month - 1));
	const endDate = new Date(year, month - 1, dateToDay);
	return endDate;
};

export const substractMonths = (date: Date, monthsToSubtract: number): Date => {
	return subMonths(date, monthsToSubtract);
};
